import { useMemo } from 'react'
import { summOrNull } from 'shared/utils/summOrNull'

export function useSummOrNull(...args: Parameters<typeof summOrNull>) {
  return useMemo(() => {
    return summOrNull(...args)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, args)
}
